<!-- 
#SBLI needs to have the agent code variable added to the link
#Needs cookie set for Moo and AmAm clicks
#Cookie based v-if for the dialog still needed
-->
<template>
    <v-container fluid class="grey lighten-5 my-0 px-0  py-0" style="max-width:1400px; margin:0 auto;">
        <template>
            <v-row class="pt-8 px-8">
                <div>
                    <h2>Carrier E-Apps</h2>
                    <p>Please click on the carrier below to access their e-app platform/software.</p>
                    <p class="body-2"><v-icon color="#46c3b2">fa-regular fa-bookmark</v-icon> Indicates a Just In Time
                        Carrier.</p>
                </div>
            </v-row>
            <v-row class="pb-8 px-8">
                <v-btn
                    href="https://dynamic-advisor-prod.techf.com/login?org=org_VXB5UCMciyy4LpyU&connection=QuilitySSO"
                    color="q_blue_1"
                    dark
                    depressed
                    large
                    target="_blank"
                    class="ml-auto"
                    >Go to Navigator
                </v-btn>
            </v-row>
            <v-row class="px-5 justify-center">
                <v-card v-for="(carrierEapp, ix) in carrierEapps" :key="ix" width="374"
                    :class="' ma-5 pa-4 ' + (carrierEapp.justInTime ? 'just_in_time' : '')">
                    <v-img max-width="250" max-height="150" class="center-image" :src="carrierEapp.logoImage"></v-img>
                    <v-card-text v-if="carrierEapp.message">
                        <a :href="carrierEapp.jitMessageLink">
                            <strong class="app-message">{{ carrierEapp.message }}</strong>
                        </a>
                    </v-card-text>
                    <v-card-actions class="mt-5">
                        <v-btn v-if="carrierEapp.justInTime && !hasCookieSet(carrierEapp.cookieKey)" color="q_blue_1"
                            dark right @click="showCarrierDialog(carrierEapp)" depressed target="_blank" bottom
                            absolute>Access</v-btn>
                        <v-btn v-else color="q_blue_1" dark right :href="(carrierEapp.appLink)" depressed
                            target="_blank" bottom absolute>Access</v-btn>
                    </v-card-actions>
                </v-card>
            </v-row>
            <v-dialog v-model="showDialog" transition="dialog-top-transition" max-width="600">
                <v-card>
                    <v-toolbar color="warning" dark>
                        New Agent Alert
					</v-toolbar>
                    <v-card-text v-if="currentCarrier.jitMessage">
                        <div v-if="Array.isArray(currentCarrier.jitMessage)" class="text-h2 pa-12">
							<p v-for="message in currentCarrier.jitMessage" :key="message">
								{{ message }}
							</p>
						</div>
                        <div v-else class="text-h2 pa-12">
							<p>{{ currentCarrier.jitMessage }}</p>
						</div>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn depressed dark color="q_blue_1" @click="setCookieAndVisitCarrier">OK</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </v-container>
</template>

<script>
import Cookies from 'js-cookie'

export default {
    data: function () {
        return {
            showDialog: false,
            currentCarrier: {},
            AmAmCookie: false,
            MooCookie: false,
        }
    },
    computed: {
        carrierEapps () {
            return [
                {
                    carrier: "AmAm",
                    logoImage: "https://hq-image-cdn.azureedge.net/servers/public/cms_images/AmAm-Logo_American-Amicable_21-03-11_800x800_JAyeN2.png",
                    message: "Instructions for Writing Applications Prior to Receiving Writing Number",
                    appLink: "https://www.insuranceapplication.com/cgi/webappmobile/login.aspx?ReturnUrl=%2fcgi%2fwebappmobile%2f",
                    justInTime: true,
                    jitMessage: [
						"If you are a new agent and previously had a writing number with AmAm thru a different IMO please do not use the E-APP until you have received a new producer number for AmAm with Symmetry.",
						"Additionally, if you live in the state of PA – you should not write an application until you receive an agent writing number from the carrier, as this state requires pre-appointment. Once your onboarding packet has been received, the contracting department will send you links for completing this carrier contract. If you have not received it yet, feel free to inquire with the contracting department.",
						"By clicking OK you are acknowledging that you have read the above.",
					],
                    jitMessageLink: "/cms/document/view/166075",
                    cookieKey: "AmAmShown"
                },
                {
                    carrier: "Moo",
                    logoImage: "https://hq-image-cdn.azureedge.net/servers/public/cms_images/MOO_Logo_Mutual-of-Omaha_21-03-11_800x800_7vL0SE.svg",
                    appLink: "https://auth.quility.com/samlp/IAIG38uVluNjOS7x5IHPvOUYP2TzcwWv?RelayState=https://pipepasstoigo.ipipeline.com/default.aspx?gaid=6503"
                },
                {
                    carrier: "Americo",
                    logoImage: "https://hq-image-cdn.azureedge.net/servers/public/cms_images/Americo-Logo_Americo_21-03-11_800x800_ADkslC.svg",
                    appLink: "https://tools.americoagent.com",
                },
                {
                    carrier: "Foresters",
                    logoImage: "https://hq-image-cdn.azureedge.net/servers/public/cms_images/Foresters_Logo_Foresters_21-03-11_800x800_jeStXK.svg",
                    message: "",
                    appLink: "https://auth.quility.com/samlp/IAIG38uVluNjOS7x5IHPvOUYP2TzcwWv?RelayState=https://pipepasstoigo.ipipeline.com/default.aspx?gaid=6503",
                },
                {
                    carrier: "JH",
                    logoImage: "https://hq-image-cdn.azureedge.net/servers/public/cms_images/JH_Logo_John-Hancock_21-03-11_800x800_RRSj2R.svg",
                    message: "",
                    appLink: "https://instant-apply.johnhancockinsurance.com/intake-brokerage?cid=US_JH_IN_IR_mm_mm_Vitality_BR_CS_LK_00_00_00_00_AW_00_00_homeheader_LauncheApp",
                },
                {
                    carrier: "NLG",
                    logoImage: "https://hq-image-cdn.azureedge.net/servers/public/cms_images/NLG_Logo_National-Life-Group_21-03-11_800x800_epQ99l.svg",
                    message: "",
                    appLink: "https://nlg-prod.auth0.com/samlp/mI5w1IaUJlcACje72K9NVFxv9xAgmUtm",
                },
                {
                    carrier: "SBLI",
                    logoImage: "https://hq-image-cdn.azureedge.net/servers/production/cms_images/SBLI%20Logo%20Small_uhlf0S.png",
                    appLink: "https://dynamic-advisor-prod.techf.com/login?org=org_VXB5UCMciyy4LpyU&connection=QuilitySSO",
                },
                {
                    carrier: "United Home Life",
                    logoImage: "https://hq-image-cdn.azureedge.net/servers/public/cms_images/UHL_Logo_United-Home-Life_21-03-11_800x800_czfRVE.svg",
                    message: "",
                    appLink: "https://auth.quility.com/samlp/IAIG38uVluNjOS7x5IHPvOUYP2TzcwWv?RelayState=https://pipepasstoigo.ipipeline.com/default.aspx?gaid=6503",
                },
                {
                    carrier: "Legal and General",
                    logoImage: "https://hq-image-cdn.azureedge.net/servers/production/cms_images/978a842c-2156-46f6-b307-f37a015bd41b_U9mVef.png",
                    appLink: "https://dynamic-advisor-prod.techf.com/login?org=org_VXB5UCMciyy4LpyU&connection=QuilitySSO",
                },
            ]
        },
        hasAmAmCookie: function () {
            return Cookies.get('AmAmShown')
        },

        hasMooCookie: function () {
            return Cookies.get('MooShown')
        },

        has_seen_dialog: function (carrier) {
            return Cookies.get(carrier.cookieKey) == 'true';
        }
    },
    methods: {
        setCookieAndVisitCarrier: function () {
            Cookies.set(this.currentCarrier.cookieKey, 'true', { expires: 365, path: '' })
            //send the user to the carrier in a new tab. 
            window.open(this.currentCarrier.appLink)
            //then close the dialog. 
            this.showDialog = false;
        },
        showCarrierDialog(carrierEapp) {
            this.currentCarrier = carrierEapp;
            this.showDialog = true;
        },
        hasCookieSet(key) {
            return !!Cookies.get(key)
        }
    },

}
</script>

<style scoped>
.just_in_time {
    /*border:solid 3px #46c3b2;*/
}

.just_in_time::before {
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    content: "\f02e";
    display: inline-block;
    position: relative;
    top: -23px;
    color: #46c3b2;
    font-size: 24px;
}

.app-message {
    font-size: 1.1rem;
}
</style>
